//
//
//
//
//
//

import debounce from 'debounce';

export default {
    props: {
        formats: { type: Array, default: function _default() {
                return [];
            }, required: true },
        flat: { type: Boolean, default: false }
    },
    data: function data() {
        return {
            file: ''
        };
    },

    methods: {
        onChange: function onChange() {
            var inputFile = this.$refs.inputFile;

            if (inputFile.files.length) {
                this.file = inputFile.files[0];
                var formDataFile = new FormData();
                formDataFile.append('inputFile', this.file);

                var extension = this.file.name.toLowerCase().split('.').pop();

                if (this.formats.length && this.formats.indexOf(extension) === -1) return this.$swal('Los formatos de archivo permitidos son los siguientes: ' + this.formats.join(','), '', 'warning');

                this.$emit('change', formDataFile);
                this.$nextTick(function () {
                    inputFile.value = '';

                    if (!/safari/i.test(navigator.userAgent)) {
                        inputFile.type = '';
                        inputFile.type = 'file';
                    }
                });
            }
        },

        openExplorer: debounce(function () {
            this.$refs.inputFile.click();
        }, 600)
    },
    mounted: function mounted() {
        this.$refs.inputFile.addEventListener('change', this.onChange.bind(this));
    },
    beforeDestroy: function beforeDestroy() {
        this.$refs.inputFile.removeEventListener('change', this.onChange);
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/shared/buttons/load-button.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/shared/buttons/load-button.vue
// module chunks = 34